import { green, grey, orange } from "@ant-design/colors"
import { faCircleCheck, faCirclePause, faCircleQuestion } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Space, Tooltip } from "antd"
import { Workarea } from "./editVisitApi"

const getIcon = (workarea: Workarea) => {
  if (workarea.isOnHold) {
    return <Tooltip title="This work area is on hold."><FontAwesomeIcon icon={faCirclePause} style={{ color: orange.primary }} /></Tooltip>
  }
  if (workarea.isApproved) {
    return <Tooltip title="This work area is approved."><FontAwesomeIcon icon={faCircleCheck} style={{ color: green.primary }} /></Tooltip>
  }
  return <Tooltip title="This work area is not approved."><FontAwesomeIcon icon={faCircleQuestion} style={{ color: grey.primary }} /></Tooltip>
}

type Props = {
  workarea: Workarea
}

const WorkareaLabel = ({ workarea }: Props) => {
  const formattedDate = workarea.scheduledDate
    ? <span style={{ color: grey[2] }}>({new Date(workarea.scheduledDate).toLocaleDateString()})</span>
    : ''
  const recurringTag = workarea.estimatedOccurrences !== undefined && workarea.estimatedOccurrences > 1
    ? <span style={{ color: grey[2] }}>(Recurring)</span>
    : ''

  return <Space>
    {getIcon(workarea)}
    {workarea.name}
    {formattedDate}{recurringTag}
  </Space>
}
export default WorkareaLabel
